<template>
  <div class="padding7 el-card">
    <el-form :model="voucherQueryModel" label-width="120px" label-position="left">
      <div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="品牌" label-width="80px">
              <el-select
                v-model="voucherQueryModel.brandId"
                placeholder="选择品牌"
                size="mini"
                class="width100"
                @change="brandChange"
                filterable
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制单日期" label-width="80px">
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                size="mini"
                style="width:100%"
                @change="timeChange"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="单据类型" label-width="80px">
              <el-select
                v-model="voucherQueryModel.orderType"
                placeholder="选择单据类型"
                size="mini"
                class="width100"
                @change="orderTypeChange"
                filterable
                multiple
                clearable
                collapse-tags
              >
                <el-option
                  v-for="item in ordersList"
                  :key="item.billTypeId"
                  :label="item.billTypeName"
                  :value="item.billTypeId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="单据状态" label-width="80px">
              <el-select
                v-model="voucherQueryModel.orderState"
                placeholder="选择单据状态"
                size="mini"
                class="width100"
                filterable
              >
                <el-option
                  v-for="state in stateList"
                  :key="state.id"
                  :label="state.name"
                  :value="state.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="制单状态" label-width="80px">
              <el-select
                v-model="voucherQueryModel.makeOrderState"
                placeholder="选择制单状态"
                size="mini"
                class="width100"
                filterable
              >
                <el-option
                  v-for="state in makeOrderStateList"
                  :key="state.id"
                  :label="state.name"
                  :value="state.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="top7">
            <el-button
              type
              size="mini"
              icon="el-icon-search"
              class="pull-left"
              @click="search"
              :disabled="!storeSel"
            >查询</el-button>
            <el-button
              type
              size="mini"
              icon="el-icon-search"
              class="pull-left right-20"
              @click="searchmore"
              :disabled="!(!!voucherQueryModel.brandId)"
            >高级查询</el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-download"
              class="pull-left"
              @click="openDialog"
              :disabled="!isSearchVal"
            >同步单据</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-table
      :data="tableData"
      size="mini"
      style="width: 100%;"
      border
      ref="tableData"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="billNO" label="单据号"></el-table-column>
      <el-table-column label="单据日期">
        <template slot-scope="scope">
          <span :class="scope.row.color" style="margin-right: 10px;"></span>
          {{dateFormat(scope.row.busDate)}}
        </template>
      </el-table-column>
      <el-table-column prop="billType" label="单据类型"></el-table-column>
      <el-table-column prop="billBusType" label="业务类型"></el-table-column>
      <el-table-column prop="otherSideName" label="对方机构"></el-table-column>
      <el-table-column prop="inStoreName" label="入库仓库" v-if="isZxndb || isZxjdb"></el-table-column>
      <el-table-column prop="outStoreName" label="出库仓库" v-if="isZxndb || isZxjdb"></el-table-column>
      <el-table-column prop="shopName" label="组织名称"></el-table-column>
      <el-table-column label="出入库">
        <template slot-scope="scope">
          <span v-if="scope.row.isOut">出库</span>
          <span v-else>入库</span>
        </template>
      </el-table-column>
      <el-table-column label="出/入库数量">
        <template slot-scope="scope">
          <span v-if="scope.row.isOut">{{scope.row.totalOutMainAmount}}</span>
          <span v-else>{{scope.row.totalInMainAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column label="出/入库金额">
        <template slot-scope="scope">
          <span v-if="scope.row.isOut">{{scope.row.totalOutStoreMoney}}</span>
          <span v-else>{{scope.row.totalInStoreMoney}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalIncloudTaxMoney" label="含税金额"></el-table-column>
      <el-table-column prop="totalSaleIncloudTaxMoney" label="销售金额"></el-table-column>
    </el-table>
    <el-row class="pull-right">
      <el-tag size="small" class="right-10">出入库金额合计:{{moneyTotalInfo.totalStoreMoney}}</el-tag>
      <el-tag
        size="small"
        class="right-20"
        type="success"
      >出入库金额本页合计:{{moneyTotalInfo.totalStoreMoneyPager}}</el-tag>
      <el-tag size="small" class="right-10">含税金额合计:{{moneyTotalInfo.totalIncloudTaxMoney}}</el-tag>
      <el-tag
        size="small"
        class="right-20"
        type="success"
      >含税金额本页合计:{{moneyTotalInfo.totalIncloudTaxMoneyPager}}</el-tag>
      <el-tag size="small" class="right-10">销售金额合计:{{moneyTotalInfo.totalSaleIncloudTaxMoney}}</el-tag>
      <el-tag size="small" type="success">销售金额本页合计:{{moneyTotalInfo.totalSaleIncloudTaxMoneyPager}}</el-tag>
    </el-row>
    <pagerBar
      ref="refPagerBar"
      :apiURL="VoucherDataApi"
      :GetData="getTableData"
      :queryParam="queryParam"
      :isInit="false"
      :errorFunc="errorHandler"
    ></pagerBar>

    <targetStore ref="targetStore"></targetStore>
    <el-dialog
      width="70%"
      title="高级查询"
      :visible.sync="searchMoreVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
    >
      <el-tabs v-model="currentSearch" @tab-click="tabpanechange">
        <el-tab-pane v-for="item in searchMoreList" :label="item.label" :name="item.id+' '">
          <el-form :model="item" label-width="120px" label-position="left">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="单据号" label-width="70px">
                  <el-input v-model="item.billNo" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="制单日期" label-width="70px">
                  <el-date-picker
                    v-model="item.busDate"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    size="mini"
                    style="width:100%"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="单据类型" label-width="70px">
                  <el-select
                    @change="billTypeChange"
                    v-model="item.billType"
                    placeholder="选择单据类型"
                    size="mini"
                    class="width100"
                    filterable
                    multiple
                    clearable
                    collapse-tags
                  >
                    <el-option
                      v-for="item in ordersList"
                      :key="item.billTypeId"
                      :label="item.billTypeName"
                      :value="item.billTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务类型" label-width="70px">
                  <el-select
                    v-model="item.billBusType"
                    placeholder="选择业务类型"
                    size="mini"
                    class="width100"
                    filterable
                    multiple
                    clearable
                    collapse-tags
                  >
                    <el-option
                      v-for="item in billBusTypeList"
                      :key="item.billBusTypeId"
                      :label="item.billBusTypeName"
                      :value="item.billBusTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单据状态" label-width="68px">
                  <el-select
                    v-model="item.orderState"
                    placeholder="选择单据状态"
                    size="mini"
                    class="width100"
                    filterable
                  >
                    <el-option
                      v-for="state in stateList"
                      :key="state.id"
                      :label="state.name"
                      :value="state.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="制单状态" label-width="68px">
                  <el-select
                    v-model="item.makeOrderState"
                    placeholder="选择单据状态"
                    size="mini"
                    class="width100"
                    filterable
                  >
                    <el-option
                      v-for="state in makeOrderStateList"
                      :key="state.id"
                      :label="state.name"
                      :value="state.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="对方机构" label-width="70px">
                  <el-input v-model="item.otherSideName" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="对方仓库" label-width="70px">
                  <el-input v-model="item.otherWarehouseName" size="mini"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="含税金额" label-width="70px">
                  <el-input-number
                    size="mini"
                    v-model="item.totalIncloudTaxMoneyMin"
                    :precision="2"
                    :step="0.1"
                  ></el-input-number>到
                  <el-input-number
                    size="mini"
                    v-model="item.totalIncloudTaxMoneyMax"
                    :precision="2"
                    :step="0.1"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="方案名称" label-width="70px">
                  <el-input v-model="item.name" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="0px">
                  <el-button
                    icon="el-icon-check"
                    type="primary"
                    size="mini"
                    class
                    @click="savePlan(item)"
                  >保存方案</el-button>
                  <el-button
                    icon="el-icon-delete"
                    type="danger"
                    size="mini"
                    @click="delPlan(item.id)"
                    v-if="item.id != 0"
                  >删除方案</el-button>
                  <el-button
                    icon="el-icon-search"
                    type="primary"
                    size="mini"
                    @click="searchPlan(item)"
                  >查询</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/common/config.js";
import pagerBar from "@/views/pager/pagerBar";
import AjaxHelper from "@/common/js/AjaxHelper";
import targetStore from "@/views/orderAdmin/storeTransfer";
export default {
  components: {
    targetStore,
    pagerBar
  },
  data() {
    return {
      isSearchVal: false,
      isVoucherCreate: false,
      queryParam: {},
      brandSel: false,
      storeSel: false,
      CurrnetMID: 0,
      CloudDataUrl: config.BASE_Middle_API + "CloudShopInfo",
      OrderCreateApi: config.BASE_Middle_API + "OrderCreate",
      VoucherCreateApi: config.BASE_Middle_API + "VoucherCreate",
      VoucherDataApi: config.BASE_Middle_API + "OrderCreate/GetCloudData", //获取源数据接口 需提供
      saveApi: config.BASE_Middle_API + "OrderCreate/CloudOrderHandle",
      Visible: false,
      optionsList: [],
      moduleList: [],
      brandList: [],
      brands: [],
      storesList: [],
      stores: [],
      ordersList: [],
      tableData: [],
      accountList: [],
      time: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      voucherQueryModel: {
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
        brandId: "",
        store: "",
        orderType: "",
        groupType: "1",
        orderIds: [],
        orderState: 0,
        makeOrderState: 0
      },
      isMultiOrg: false,
      selOrder: [],
      selOrderIds: [],
      multipeleSelectedIds: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              const end = start;
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchMoreVisible: false,
      currentSearch: "0 ",
      searchMoreList: [],
      searchMoreEmpty: {
        label: "高级查询",
        name: "",
        id: "0",
        billNo: "",
        busDate: [],
        billType: [],
        billBusType: [],
        otherSideName: "",
        otherWarehouseName: "",
        orderState: 0,
        makeOrderState: 0
      },
      billBusTypeList: [],
      billBusTypeListTemp: [],
      moneyTotalInfo: {
        totalIncloudTaxMoney: 0,
        totalIncloudTaxMoneyPager: 0,
        totalStoreMoney: 0,
        totalStoreMoneyPager: 0,
        totalSaleIncloudTaxMoney: 0,
        totalSaleIncloudTaxMoneyPager: 0
      },
      moneyTotalInfoZero: {
        totalIncloudTaxMoney: 0,
        totalIncloudTaxMoneyPager: 0,
        totalStoreMoney: 0,
        totalStoreMoneyPager: 0,
        totalSaleIncloudTaxMoney: 0,
        totalSaleIncloudTaxMoneyPager: 0
      },
      searchDataTemp: {},
      isZxjdb: false,
      isZxndb: false,
      stateList: [],
      makeOrderStateList: []
    };
  },
  props: {
    openloading: {
      type: Function,
      required: true
    },
    closeloading: {
      type: Function,
      required: true
    },
    tabType: {
      type: String,
      required: true
    }
  },

  mounted() {
    this.getModules();
    this.getOrderTypes();
    this.getbillBusTypes();
    this.stateList.push({ id: 0, name: "全部" });
    this.stateList.push({ id: 1, name: "已审" });
    this.stateList.push({ id: 2, name: "复审" });
    this.makeOrderStateList.push({ id: 0, name: "全部" });
    this.makeOrderStateList.push({ id: 1, name: "未制单" });
  },
  methods: {
    getRowKeys(row) {
      return row.billNO;
    },
    handleSelectionChange(val) {
      const _this = this;
      if (_this.selOrder.length == 0) {
        _this.selOrder.push({
          key: _this.$refs.refPagerBar.currentPage,
          value: val
        });
      } else {
        let b = false;
        _this.selOrder.forEach(item => {
          if (item.key == _this.$refs.refPagerBar.currentPage) {
            b = true;
            item.value = val;
          }
        });
        if (!b) {
          _this.selOrder.push({
            key: _this.$refs.refPagerBar.currentPage,
            value: val
          });
        }
      }
    },
    // handleSelectionChange(val) {
    //   this.multipeleSelectedIds = val;
    // },
    // 选中table已有数据
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$nextTick(() => {
            let checked = this.tableData.find(
              tableRow => tableRow.billNO === row.billNO
            );
            this.$refs.tableData.toggleRowSelection(checked);
          });
        });
      } else {
        this.$refs.tableData.clearSelection();
      }
    },
    tableSelectHandler(selection, row) {
      const _this = this;
      let allRows = selection.filter(item => !!item);
      if (allRows.find(item => item.billNO === row.billNO)) {
        _this.addRows([row]);
      } else {
        _this.removeRows([row]);
      }
    },
    addRows(rows) {
      const _this = this;
      for (let key of rows) {
        if (!_this.selOrder.find(item => item.billNO === key.billNO)) {
          this.selOrder.push(key);
        }
      }
    },
    // 取消选中行
    removeRows(rows) {
      const _this = this;
      if (_this.selOrder.length > 0) {
        for (let row of rows) {
          _this.selOrder = _this.selOrder.filter(
            item => item.billNO !== row.billNO
          );
        }
      }
    },
    tableSelectAllHandler(selection) {
      //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
      selection.forEach((e, index) => {
        if (e === undefined) {
          selection.splice(index, 1);
        }
      });
      // 如果有则是全选否则就是全取消
      if (selection.length > 0) {
        this.addRows(this.tableData);
      } else {
        this.removeRows(this.tableData);
      }
    },
    dateFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    timeChange(val) {
      this.voucherQueryModel.startTime = moment(val[0]).format("YYYY-MM-DD");
      this.voucherQueryModel.endTime = moment(val[1]).format("YYYY-MM-DD");
    },
    errorHandler() {
      this.closeloading();
    },
    search() {
      this.openloading();
      this.$refs.tableData.clearSelection();
      if (this.voucherQueryModel.brandId == "") {
        this.$message({
          type: "error",
          position: "bottom-right",
          message: "请先选择品牌"
        });
        this.closeloading();
        return;
      }
      let confirmData = Object.assign({}, this.voucherQueryModel);
      confirmData.storeID = 1;
      confirmData.storeCode = "";
      if (
        this.voucherQueryModel.orderType == null ||
        this.voucherQueryModel.orderType == []
      ) {
        let orderTypeCode = [];
        this.ordersList.map(x => {
          orderTypeCode.push(x.billTypeCode);
        });
        confirmData.billTypes = orderTypeCode.join(",");
      } else {
        confirmData.billTypes = this.voucherQueryModel.orderType.join(",");
      }
      confirmData.orderState = this.voucherQueryModel.orderState;
      confirmData.makeOrderState = this.voucherQueryModel.makeOrderState;
      confirmData.groupType = this.voucherQueryModel.groupType;
      this.queryParam = Object.assign({}, confirmData);
      this.searchDataTemp = {};
      this.searchDataTemp = Object.assign({}, confirmData);
      //this.getTotalAmt(confirmData);
    },
    //切换方案后修改业务类型数据源
    tabpanechange(tab, event) {
      var val = [];
      this.searchMoreList.map(x => {
        if (tab.name == x.id + " ") {
          val = x.billType;
        }
      });
      this.billBusTypeListChange(val);
    },
    //选择单据类型后修改业务类型数据源
    billTypeChange(val) {
      this.billBusTypeListChange(val);
      this.tableData = [];
    },
    //修改业务类型数据源
    billBusTypeListChange(val) {
      const _this = this;
      if (val == null || val == [] || val.length == 0) {
        _this.billBusTypeList = JSON.parse(
          JSON.stringify(_this.billBusTypeListTemp)
        );
      } else {
        _this.billBusTypeList = [];
        _this.zxjdb = false;
        _this.zxndb = false;
        _this.billBusTypeListTemp.map(x => {
          //val 单据类型的值数组
          val.map(y => {
            if (x.billTypeId == y) {
              _this.billBusTypeList.push(x);
            }
          });
        });
      }
    },
    //打开高级查询对话框
    searchmore() {
      this.searchMoreVisible = true;
      this.initSearchPlan();
    },
    //获得查询方案
    initSearchPlan() {
      const _this = this;
      _this.$nextTick(function() {
        AjaxHelper.get(_this.VoucherCreateApi + "/GetSearchPlans", {
          ModuleMark: "SCM"
        })
          .then(function(response) {
            if (response.success) {
              _this.searchMoreList = [];
              _this.searchMoreList.push(_this.searchMoreEmpty);
              if (response.result != null && response.result.length > 0) {
                response.result.forEach(item => {
                  item.label = item.name;
                  if (!!item.billTypes) {
                    item.billType = item.billTypes.split(",");
                  }
                  if (!!item.billBusTypes) {
                    item.billBusType = item.billBusTypes.split(",");
                  }
                  var busDate = [];
                  if (item.busDateBegin != null && item.busDateEnd != null) {
                    busDate.push(
                      new moment(item.busDateBegin).format("YYYY-MM-DD")
                    );
                    busDate.push(
                      new moment(item.busDateEnd).format("YYYY-MM-DD")
                    );
                  }
                  item.busDate = busDate;
                  if (item.totalIncloudTaxMoneyMin == null) {
                    item.totalIncloudTaxMoneyMin = undefined;
                  }
                  if (item.totalIncloudTaxMoneyMax == null) {
                    item.totalIncloudTaxMoneyMax = undefined;
                  }
                  if (item.orderState == null) {
                    item.ordersList = 0;
                  }
                  _this.searchMoreList.push(item);
                });
              }
            }
          })
          .catch(function(error) {});
      });
    },
    //删除查询方案
    delPlan(id) {
      const _this = this;
      AjaxHelper.post(_this.VoucherCreateApi + "/SearchPlanDelete", { id: id })
        .then(function(response) {
          if (response.success) {
            _this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              position: "bottom-right"
            });
            _this.initSearchPlan();
            _this.currentSearch = "0 ";
          }
        })
        .catch(function(error) {
          _this.$notify({
            title: "提示",
            message: error.message,
            type: "error",
            position: "bottom-right"
          });
        });
    },
    //高级查询
    searchPlan(item) {
      const _this = this;
      var b = _this.checkSearchPlan(item);
      if (b) {
        _this.searchMoreVisible = false;
        _this.openloading();
        if (_this.voucherQueryModel.brandId == "") {
          _this.$message({
            type: "error",
            position: "bottom-right",
            message: "请先选择品牌"
          });
          _this.closeloading();
          return;
        }
        let confirmData = Object.assign({}, _this.voucherQueryModel);
        confirmData.storeID = 1;
        confirmData.storeCode = "";
        confirmData.billNo = item.billNo;
        confirmData.otherSideName = item.otherSideName;
        confirmData.otherWarehouseName = item.otherWarehouseName;
        confirmData.orderState = item.orderState;
        confirmData.makeOrderState = item.makeOrderState;
        //处理业务类型
        if (item.billBusType != null && item.billBusType != []) {
          confirmData.billBusTypes = item.billBusType.join(",");
        } else {
          confirmData.billBusTypes = "";
        }
        //处理单据类型
        if (
          item.billType != null &&
          item.billType != [] &&
          item.billType.length > 0
        ) {
          //高级查询勾选单据类型，则页面查询同步
          _this.voucherQueryModel.orderType = item.billType;
          confirmData.billTypes = item.billType.join(",");
        } else {
          //高级查询不勾选单据类型，则以页面查询为准
          if (
            _this.voucherQueryModel.orderType == null ||
            _this.voucherQueryModel.orderType == []
          ) {
            let orderTypeCode = [];
            _this.ordersList.map(x => {
              orderTypeCode.push(x.billTypeCode);
            });
            confirmData.billTypes = orderTypeCode.join(",");
          } else {
            confirmData.billTypes = _this.voucherQueryModel.orderType.join(",");
          }
        }
        //处理日期
        if (item.busDate != [] && item.busDate.length == 2) {
          //高级查询处理了日期，则页面查询同步
          _this.time = item.busDate;
          confirmData.startTime = moment(item.busDate[0]).format("YYYY-MM-DD");
          confirmData.endTime = moment(item.busDate[1]).format("YYYY-MM-DD");
        } else {
          confirmData.startTime = this.voucherQueryModel.startTime;
          confirmData.endTime = this.voucherQueryModel.endTime;
        }
        //处理金额
        confirmData.totalIncloudTaxMoneyMin =
          item.totalIncloudTaxMoneyMin == undefined
            ? null
            : item.totalIncloudTaxMoneyMin;
        confirmData.totalIncloudTaxMoneyMax =
          item.totalIncloudTaxMoneyMax == undefined
            ? null
            : item.totalIncloudTaxMoneyMax;
        confirmData.groupType = _this.voucherQueryModel.groupType;
        _this.queryParam = Object.assign({}, confirmData);
        _this.searchDataTemp = {};
        _this.searchDataTemp = Object.assign({}, confirmData);
        //_this.getTotalAmt(confirmData);
      }
    },
    //保存查询方案
    savePlan(item) {
      const _this = this;
      if (!!!item.name) {
        _this.$notify({
          title: "提示",
          message: "请输入方案名称",
          type: "error",
          position: "bottom-right"
        });
        return false;
      }
      item.moduleMark = "SCM";
      var b = _this.checkSearchPlan(item);
      if (b) {
        AjaxHelper.post(
          _this.VoucherCreateApi + "/SearchPlanCreateOrEdit",
          item
        )
          .then(function(response) {
            if (response.success) {
              _this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                position: "bottom-right"
              });
              _this.initSearchPlan();
            }
          })
          .catch(function(error) {
            _this.$notify({
              title: "提示",
              message: error.message,
              type: "error",
              position: "bottom-right"
            });
          });
      }
    },
    //检查查询方案正确性
    checkSearchPlan(item) {
      const _this = this;
      var b = false;
      if (item.busDate != null && item.busDate.length == 2) {
        b = true;
        item.busDateBegin = moment(item.busDate[0]).format("YYYY-MM-DD");
        item.busDateEnd = moment(item.busDate[1]).format("YYYY-MM-DD");
      }
      if (item.billType != null && item.billType.length > 0) {
        b = true;
        item.billTypes = item.billType.join(",");
      }
      if (item.billBusType != null && item.billBusType.length > 0) {
        b = true;
        item.billBusTypes = item.billBusType.join(",");
      }
      if (!!item.billNo) {
        b = true;
      }
      if (!!item.otherSideName) {
        b = true;
      }
      if (!!item.otherWarehouseName) {
        b = true;
      }
      if (
        (item.totalIncloudTaxMoneyMin != undefined ||
          item.totalIncloudTaxMoneyMax != undefined) &&
        item.totalIncloudTaxMoneyMin != item.totalIncloudTaxMoneyMax
      ) {
        b = true;
      }
      if (
        item.totalIncloudTaxMoneyMin != undefined &&
        item.totalIncloudTaxMoneyMax != undefined &&
        item.totalIncloudTaxMoneyMin == item.totalIncloudTaxMoneyMax
      ) {
        _this.$notify({
          title: "提示",
          message: "含税金额两个值不能相同",
          type: "error",
          position: "bottom-right"
        });
        return false;
      }
      if (!b) {
        _this.$notify({
          title: "提示",
          message: "请输入查询项",
          type: "error",
          position: "bottom-right"
        });
        return false;
      }
      return b;
    },
    //本次查询合计，本页合计
    getTotalAmt(item) {
      const _this = this;
      _this.openloading();
      AjaxHelper.get(_this.OrderCreateApi + "/GetTotalAmt", item)
        .then(function(response) {
          if (response.success) {
            _this.moneyTotalInfo.totalIncloudTaxMoney =
              response.result.totalIncloudTaxMoney;
            _this.moneyTotalInfo.totalStoreMoney =
              response.result.totalStoreMoney;
            _this.moneyTotalInfo.totalSaleIncloudTaxMoney =
              response.result.totalSaleIncloudTaxMoney;
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    voucherCreateShow() {
      const _this = this;
      _this.openloading();
      _this.selOrder.forEach(item => {
        if (item.value != null && item.value.length > 0) {
          item.value.forEach(v => {
            _this.selOrderIds.push(v.billNO);
          });
        }
      });
      //凭证生成接口
      _this.voucherQueryModel.orderIds = _this.selOrderIds;
      const confirmData = _this.voucherQueryModel;
      AjaxHelper.post(_this.OrderCreateApi + "/CloudOrderHandle", confirmData)
        .then(function(response) {
          if (response.result.isSuccess) {
            {
              _this.$notify({
                title: "提示",
                message: response.result.successMsg,
                type: "success",
                position: "bottom-right"
              });
            }
          } else {
            _this.$notify({
              title: "提示",
              message: response.result.errorMsg,
              type: "error",
              position: "bottom-right"
            });
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    openDialog() {
      const _this = this;
      _this.selOrderIds = [];
      _this.selOrder.forEach(item => {
        if (item.value != null && item.value.length > 0) {
          item.value.forEach(v => {
            _this.selOrderIds.push(v.billNO);
          });
        }
      });
      _this.voucherQueryModel.orderIds = _this.selOrderIds;
      _this.voucherQueryModel.vouchernumber =
        _this.$refs.refPagerBar.pagerTotal;
      if (_this.isMultiOrg) {
        AjaxHelper.get(
          _this.OrderCreateApi +
            "/GetStoreList?brandId=" +
            _this.voucherQueryModel.brandId
        ).then(function(response) {
          if (response.success) {
            if (response.result != null && response.result.length > 0) {
              _this.$refs.targetStore.createDialog(
                true,
                response.result,
                _this.voucherQueryModel,
                _this.searchDataTemp
              );
            } else {
              _this.$message({
                type: "error",
                position: "bottom-right",
                message: "未找到多组织档案对照信息"
              });
            }
          }
        });
      } else {
        _this.voucherCreateShow();
      }
    },
    voucherCreate() {
      if (this.voucherQueryModel.groupType == "") {
        this.$message({
          type: "error",
          message: "请选择凭证生成方式",
          position: "bottom-right"
        });
        return false;
      }
    },
    getAccount() {
      const _this = this;
      this.openloading();
      AjaxHelper.get(
        _this.OrderCreateApi +
          "/GetAccountBooks?brandId=" +
          _this.voucherQueryModel.brandId
      )
        .then(function(response) {
          if (response.success) {
            _this.accountList = response.result;
            _this.voucherQueryModel.account = _this.accountList[0].number;
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    getTableData(d) {
      const _this = this;
      _this.tableData = d;
      //查询无结果 不允许生成凭证
      if (d.length > 0) {
        _this.isSearchVal = true;
        _this.getTotalAmt(_this.searchDataTemp);
        let totalIncloudTaxMoneyPager = 0; //含税金额本页
        let totalStoreMoneyPager = 0; //出入库金额本页
        let totalSaleIncloudTaxMoneyPager = 0; //销售金额本页
        d.forEach(item => {
          if (item.isOut) {
            totalStoreMoneyPager += item.totalOutStoreMoney;
          } else {
            totalStoreMoneyPager += item.totalInStoreMoney;
          }
          totalIncloudTaxMoneyPager += item.totalIncloudTaxMoney;
          totalSaleIncloudTaxMoneyPager += item.totalSaleIncloudTaxMoney;
        });
        _this.moneyTotalInfo.totalIncloudTaxMoneyPager = parseFloat(
          totalIncloudTaxMoneyPager
        ).toFixed(2);
        _this.moneyTotalInfo.totalStoreMoneyPager = parseFloat(
          totalStoreMoneyPager
        ).toFixed(2);
        _this.moneyTotalInfo.totalSaleIncloudTaxMoneyPager = parseFloat(
          totalSaleIncloudTaxMoneyPager
        ).toFixed(2);
      } else {
        _this.isSearchVal = false;
        //_this.moneyTotalInfo = Object.assign({}, _this.moneyTotalInfoZero); ;
      }
      if (_this.selOrder.length) {
        _this.selOrder.forEach(item => {
          if (item.key == _this.$refs.refPagerBar.currentPage) {
            _this.toggleSelection(item.value);
          }
        });
      }
      _this.closeloading();
    },
    orderTypeChange(val) {
      if (this.voucherQueryModel.brandId == "") {
        this.storeSel = false;
      } else {
        this.storeSel = true;
      }
      this.billBusTypeChange(val);
      this.tableData = [];
    },
    billBusTypeChange(val) {
      const _this = this;
      if (val == null || val == [] || val.length == 0) {
        _this.billBusTypeList = JSON.parse(
          JSON.stringify(_this.billBusTypeListTemp)
        );
        _this.isZxjdb = false;
        _this.isZxndb = false;
      } else {
        _this.billBusTypeList = [];
        _this.isZxjdb = false;
        _this.isZxndb = false;
        _this.billBusTypeListTemp.map(x => {
          //val 单据类型的值数组
          val.map(y => {
            if (x.billTypeId == y) {
              _this.billBusTypeList.push(x);
            }
            _this.ordersList.map(z => {
              if (z.billTypeId == y && z.billTypeName == "中心间调拨") {
                _this.isZxjdb = true;
              }
              if (z.billTypeId == y && z.billTypeName == "中心内调拨") {
                _this.isZxndb = true;
              }
            });
          });
        });
      }
    },
    accountChange(val) {},
    brandChange(val) {
      this.brandSel = true;
      this.isSearchVal = false;
      if (this.voucherQueryModel.orderType == "") {
        this.storeSel = false;
      } else {
        this.storeSel = true;
      }
      var brandInfo = this.brands.filter(x => x.id == val)[0];
      this.isMultiOrg = brandInfo.isMutilOrg;
      this.voucherQueryModel.store = "";
      this.voucherQueryModel.orderType = "";
      this.storesList = this.stores.filter(
        x => x.brandID === this.voucherQueryModel.brandId
      );
    },
    statusSearch(item) {
      this.storeSel = false;
      this.brandSel = false;
      this.CurrnetMID = item.id;
      this.voucherQueryModel.brandId = "";
      this.voucherQueryModel.orderType = "";
      this.brandList = this.brands.filter(x => x.moduleID == item.id);
      this.isSearchVal = false;
    },
    getOrderTypes() {
      const _this = this;
      _this.openloading();
      AjaxHelper.get(_this.OrderCreateApi + "/GetCloudOrderTypes")
        .then(function(response) {
          if (response.success) {
            _this.ordersList = response.result;
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    getbillBusTypes() {
      const _this = this;
      _this.openloading();
      AjaxHelper.get(_this.OrderCreateApi + "/GetCloudBillBusTypes")
        .then(function(response) {
          if (response.success) {
            _this.billBusTypeListTemp = response.result;
            _this.billBusTypeList = response.result;
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    getModules() {
      const _this = this;
      this.openloading();
      AjaxHelper.get(
        _this.OrderCreateApi + "/GetModules?tabType=" + _this.tabType
      )
        .then(function(response) {
          if (response.success) {
            _this.moduleList = response.result.modules;
            if (_this.moduleList.length > 0) {
              const firstItem = _this.moduleList[0];
              _this.CurrnetMID = firstItem.id;
              _this.brands = response.result.brands;
              _this.stores = response.result.stores;
              _this.brands.forEach(x => {
                _this.moduleList.forEach(element => {
                  if (element.id == x.moduleID) {
                    _this.brandList.push(x);
                  }
                });
              });
            }
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    pickerOptions2() {},
    initData() {},

    handleClose(done) {
      this.isVoucherCreate = false;
      done();
    }
  }
};
</script>

<style scoped>
.minicard {
  height: auto !important;
  display: block;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 9989;
  top: 80px;
}
.minicard .el-button {
  width: 150px;
  margin: 5px 0;
}
.el-dialog__body {
  padding: 10px 15px !important;
}

dl.loglist p {
  font-weight: 600;
  margin: 20px 0 10px 0;
}
dl.loglist dd {
  padding: 15px 0;
  color: #999999;
  display: block;
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.w25 {
  width: 25%;
  float: left;
}
.w75 {
  width: 75%;
  float: left;
}
.el-card {
  border: 0;
  height: calc(100vh - 225px);
  overflow-y: auto;
}
.padding7 {
  padding: 7px;
}
.top5 {
  padding: 5px 0 0 0;
}
.top7 {
  padding: 7px 0 0 0;
}
</style>
